module.exports = __webpack_public_path__ + "img/symbol_starblue.58211ec7.png";